module.exports = __webpack_public_path__ + "media/news1.e047f68b.mp4";